<template>
  <div class="inventory--tab">
    <div v-if="isAllocations">
      <allocations-tabs :salesOrderLineId="salesOrderLineId" :reqLineId="crfqLineId" :partId="partId" @on-refresh-list="$emit('on-refresh-list')" />
    </div>
    <div v-else>
      <b-row class="grid-header">
        <b-col cols="6" v-if="partId || showFilter">
          <b-form-group>
            <b-form-checkbox-group
              v-model="fiteredInventory"
              :options="filterOptions"
            ></b-form-checkbox-group>
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <div class="pull-right tools">
            <b-button
              v-if="checkClaim(CAN_EDIT_REQUIREMENTS) && !hideActions && !hidePostSource"
              size="sm"
              variant="primary"
              :disabled="checkedRowItemIds.length == 0"
              @click="onAddToSources()"
              class="mr-1">
              Post to Source
            </b-button>
            <b-button v-b-modal.add-consignment-modal size="sm" variant="primary" v-if="!hideActions" class="mr-1">
              <i class="fa fa-plus mr-1" aria-hidden="true"></i>Add Consignment
            </b-button>
            <b-button @click="$bvModal.show('import-company-part-modal')" size="sm" variant="primary" class="mr-1" v-if="!hideActions">
              <i class="fa fa-plus mr-1" aria-hidden="true"></i>Import Excess Parts
            </b-button>
            <b-button @click="onPrintClick" size="sm" variant="primary" :disabled="!selectedRowItemId" v-if="!hidePrint" class="mr-1">
              Print Label
            </b-button>
            <b-button size="sm" variant="primary" :disabled="!selectedRowItemId" v-b-modal="'inspection-report-modal-inventory'" v-if="!hideReports" class="mr-1">
              <span class="fa fa-check mr-1"></span>QC Inspection
            </b-button>
            <!-- <b-button size="sm" variant="primary" :disabled="!selectedRowItemId" v-b-modal="'ncm-report-modal-inventory'" v-if="!hideReports">
              <span class="fa fa-file mr-1"></span>NCM
            </b-button> -->
            <b-button size="sm" variant="primary" :disabled="!selectedRowItemId" @click="$refs.ncmReport.show()" v-if="!hideReports" class="mr-1">
              <span class="fa fa-file mr-1"></span>Create NCM
            </b-button>
            <b-button size="sm" variant="primary" v-b-modal="'inventory-form-modal'" :disabled="partId == 0" class="mr-1"  v-if="!hideActions"> Create Inventory </b-button>
            <add-consignment :partDetails="selectedRowData" :companyInfo="{}" :editDetails="{}" />
            <fast-report-viewer ref="inventory-print" :moduleName="'Inventory'" :parameter="selectedRowItemId" v-if="!hidePrint" />
            <inventory-form v-if="isShowCreatePartInventory" :partId="partId" @part-inventory-success="onPartInventoryCreated" />
            <add-company-parts @refreshGrid="onPartInventoryCreated" v-if="!hideActions" />
          </div>
        </b-col>
      </b-row>
      <!-- TODO: Implement sorting in other areas such as sub-tabs -->
      <!--:styleCustom="(itemData.length > 0) ? 'height: 160px' : ''"-->
      <grid-component
          isResizable
          isReorderable
          :isSortable="!(partId)"
          :canEdit="checkClaim(CAN_EDIT_INVENTORY)"
          :canDelete="checkClaim(CAN_DELETE_INVENTORY)"
          :gridId="gridId"
          :itemData="itemData"
          :fields="inventoryGridIdFields"
          :navigationField="'partNumber'"
          :onDynamicVal="showDetail"
          :onEdit="openEdit"
          :onDelete="onDelete"
          :handleRowClick="onRowClick"
          :sortBy="!(partId) ? filterInfo.sortBy : null"
          :sortOrder="!(partId) ? filterInfo.sortOrder : null"
          :sortMethod="!(partId) ? sortInventoryFiltered : null"
          :checkBoxValues="checkedRowItemIds"
          @checkedItem="checkedRowItemIds=$event"
          :styleCustom="'height: 160px'"
          :dynamicValToLink="'-split-'"
        />

        <b-modal id="split-details-modal" ref="split-details-modal" size="lg" ok-only>
            <template slot="modal-header">
                <h5 class="modal-title">
                    {{ 'Inventory Split Details for Part ' + inventoryOnSplit.partNumber }}
                    <i v-show="isLoadingSplit" class="fa fa-spinner fa-pulse fa-fw"></i>
                </h5>
            </template>
            <inventory-split-component />
        </b-modal>

        <!-- QC Inspection -->
        <b-modal id="inspection-report-modal-inventory" ref="inspection-report-modal" size="xl"
                hide-footer header-close-label="Cancel" title="Inspection Report">
          <inspection-report-component :lineData="inspectionReportObj" />
        </b-modal>

        <!-- NCM REPORT -->
        <!-- <ncm-report-component :poLine="poLineInventory" :ncmObject="ncmReportObj" :modalId="'ncm-report-modal-inventory'" /> -->
        <ncm-form ref="ncmReport" :inventoryProp="selectedRowData" />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState, mapActions, mapMutations } from 'vuex';
import { GRID_PAGE_SIZES, PAGE_SIZE, GRID_ID } from '@/shared/constants';
import GridSettings from '@/shared/components/GridSettings';
import ProductAlert from '@/shared/components/ProductAlert';
import AddConsignment from '@/shared/components/Consignments/components/Add';
import { ALERT_LOCATION } from '@/shared/constants'
import { dateTime, date } from '@/shared/filters';
import { sortChange, prepareColumnsData } from '@/shared/helpers';
import GridComponent from '@/shared/components/GridComponent';
import AllocationsTabs from '@/shared/components/Allocations';
import InventorySplitComponent from '@/shared/components/InventorySplits';
import { DEFAULT_SORT_BY, FIELDS } from '@/pages/Inventory/constants';
import inventoryFields from '@/pages/Inventory/fields';
import { receivedInventoryFields } from '@/pages/Inventory/fields';
import { addSourceInventoryFields } from './fields';
import AddCompanyParts from '@/shared/components/CompanyParts/components/Add';
import { eventBus } from '@/main';
import FastReportViewer from '@/shared/components/FastReportViewer';
import InspectionReportComponent from '@/shared/components/InspectionReport/components/Form'
import InventoryForm from '@/shared/components/InventoryForm';
import NcmForm from '@/pages/NonconformanceReport/components/Form'

export default {
  data: () => ({
    date,
    prepareColumnsData,
    inventoryList: [],
    //fields: addSourceFields,
    checkedRowItemIds: [],
    checkedRowItemsObjArr: [],
    skip: 0,
    take: 5,
    //gridId: GRID_ID.INVENTORY,
    pageable: {
      pageSizes: GRID_PAGE_SIZES,
    },
    location: ALERT_LOCATION.PART_INVENTORY,
    selectedRowItemId: 0,
    selectedRowData: {},
    filters: {},
    isLoadingSplit: false,
    inventoryOnSplit: {},
    sourceFields: addSourceInventoryFields,
    receivedFields: receivedInventoryFields,
    fiteredInventory: [1],
    inspectionReportObj: {},
    ncmReportObj: {},
    poLineInventory: {},
    allSelected: false,
    indeterminate: false,
    filterOptions: [
      { text: 'All', value: 0, indeterminate: false },
      { text: 'Local', value: 1, indeterminate: false },
      { text: 'OEM Excess', value: 2, indeterminate: false },
      { text: 'Vendor Excess', value: 3, indeterminate: false },
      { text: 'Consignment', value: 4, indeterminate: false },
      { text: 'In Testing', value: 5, indeterminate: false },
    ]
  }),
  props: {
    partId: [Number, String],
    fields: {
      default() {
        return inventoryFields;
      },
      type: Array,
    },
    gridId: {
      default: GRID_ID.INVENTORY,
      type: [String],
    },
    crfqLineId: [Number, String],
    salesOrderLineId: {
      type: [Number, String],
      default: 0
    },
    purchaseOrderLineId: {
      type: [Number, String],
      default: 0
    },
    inventoryId: {
      type: [Number, String],
      default: 0
    },
    hidePostSource: {
      type: Boolean,
      default: false
    },
    inventorySourceFilters: {
      type: Object,
      default: null,
    },
    clearListOnPart: {
      type: Boolean,
      default: false
    },
    hideActions: {
      type: Boolean,
      default: false
    },
    hidePrint: {
      type: Boolean,
      default: false
    },
    showFilter: {
      type: Boolean,
      default: false
    },
    hideReports: {
      type: Boolean,
      default: false
    },
    isShowCreatePartInventory: {
      type: Boolean,
      default: false
    },
    isAllocations: {
      type: Boolean,
      default: false
    },
    parentItems: {
      type: Array,
      default: () => []
    },
    parentCheckedItems: {
      type: Array,
      default: () => []
    },
    quoteLineId: {
      type: [Number, String],
      default: 0
    },
    isQuoteLineView: [Boolean]
  },
  computed: {
    // ...mapState('inventory', [
    //   'inventoryListFiltered',
    //   'pageInfo',
    // ]),
    ...mapGetters('inventory', [
      'inventoryListFiltered',
      'pageInfo',
      'inventoryListForPartById',
      'filterInfo'
    ]),
    ...mapGetters('account', ['gridSettingsById', 'userId']),
    gridSettings() {
      return this.gridSettingsById(this.gridId);
    },
    inventoryListForPart() {
      return this.inventoryListForPartById(this.partId);
    },
    itemData() {
      let inventoryListType = (this.parentItems.length) ? this.parentItems : (this.partId) ? this.inventoryListForPart : this.inventoryListFiltered;
      if(this.partId || this.showFilter){
        inventoryListType = inventoryListType.filter((inventory) => this.fiteredInventory.includes(inventory.sourceId));
      }
      return inventoryListType.map((inventory) => ( { ...inventory, selected: inventory.id === this.selectedRowItemId }));
    },
    inventoryGridIdFields() {
      return this.gridId == GRID_ID.INVENTORY_SOURCES ? this.sourceFields : this.gridId == GRID_ID.INVENTORY_RECEIVED ? this.receivedFields : this.fields;
    }
  },
  components: {
    ProductAlert,
    GridSettings,
    GridComponent,
    AllocationsTabs,
    InventorySplitComponent,
    AddConsignment,
    FastReportViewer,
    InspectionReportComponent,
    InventoryForm,
    NcmForm,
    AddCompanyParts
  },
  filters: {
    date,
    dateTime,
  },
  methods: {
    ...mapActions('inventory', [
      // 'getInventoryByPartId',
      'getInventoryFiltered',
      'deleteInventory',
      'getInventoryAvailableParts',
      // 'getByPurchaseOrderLineId',
      'getInventorySplits',
      'sortInventoryFiltered'
    ]),
    ...mapActions('requirements', ['addToSources']),
    ...mapActions('account', ['saveGridSettings']),
    ...mapActions('purchaseorders', ['deleteReceived']),
    ...mapActions('quoteLineSources', {addQuoteLineSource: 'addSources'}),
    // ...mapMutations('inventory', [ 'setInventoryListForPart', 'setInventorySplitList', 'clearInventoryListFiltered' ]),
    ...mapMutations('inventory', [ 'setInventoryListForPart']),
    ...mapMutations('inventory', {inventorySetItem: 'setItem'}),
    onRowClick(row) {
      this.selectedRowItemId = row.dataItem.id;
      this.selectedRowData = row.dataItem;
      this.inspectionReportObj = this.readyMadeInspectionReport(row.dataItem);
      this.ncmReportObj = this.readyMadeNcmReport(row.dataItem);
      this.poLineInventory = this.readyMadePOLineInventory(row.dataItem);
      this.$emit('selectedSourceObj', row.dataItem);
    },
    onPrintClick() {
      this.$refs['inventory-print'].showModal();
    },
    openEdit(row){
      this.$router.push({
        name: 'inventory.partDetails',
        params: { id: row.id },
      });
    },
    onDelete: async function(item) {
      const deleteConfirmed = await this.openConfirmBox({message: 'Are you sure you want to delete this inventory?'});
      if (deleteConfirmed) {
        if (this.purchaseOrderLineId) {
          this.$snotify.info('Deleting in progress', 'Deleting Received');

          const result = await this.deleteReceived({
            poLineId: this.purchaseOrderLineId,
            inventoryId: item.id,
          });

          if (result.status == 200) {
            this.$snotify.success('Receiving Saved', 'Receive Purchase Order Line');
            await this.getInventoryFiltered({purchaseOrderLineId: this.purchaseOrderLineId});
            this.$emit('deletedReceivedItem', item.allocated);
          }
        } else {
          await this.deleteInventory(item.id);
          if (this.partId) {
            this.getInventoryAvailableParts(this.partId);
              this.$emit('inventory-created');
          } else {
            this.getInventoryFiltered(this.filters)
          }
        }
      }
    },
    async onAddToSources() {
      //const selectedOfferList = await this.createSourceList();
      //this.addToSources(selectedOfferList);
      this.$snotify.info('Posting Inventory to Source', 'Sources');
      if (this.isQuoteLineView) {
        await this.addQuoteLineSource(this.checkedRowItemsObjArr).then(() => {
          this.checkedRowItemIdsArr = this.checkedRowItemsObjArr = [];
          this.$snotify.success('Posted Inventory to Source', 'Sources');
        });  
      } else {
        await this.addToSources(this.checkedRowItemsObjArr).then(() => {
          this.checkedRowItemIdsArr = this.checkedRowItemsObjArr = [];
          this.$snotify.success('Posted Inventory to Source', 'Sources');
        });
      }
    },
    async getInventoryList() {

      await this.getInventoryAvailableParts(this.partId);
    },
    async showDetail(row) {
      try {
        this.isLoadingSplit = true;
        // this.setInventorySplitList([]);
        this.inventorySetItem({ resource:'inventorySplitList', payload: [] });
        this.inventoryOnSplit = row;
        this.$bvModal.show('split-details-modal');
        await this.getInventorySplits(row.id);
        this.isLoadingSplit = false;
      }catch (e) {
        this.isLoadingSplit = false;
        /*console.log(e.message);*/
      }
    },
    readyMadeInspectionReport(item) {
      return {
        ...item,
        id: item.purchaseOrderLineId,
        inventoryId: item.id,
        ordered: item.onHand
      };
    },
    readyMadeNcmReport(item) {
      return {
				id: 0,
				purchaseOrderLineId: item.purchaseOrderLineId,
				inspectedByUserId: this.userId,
				dateInspected: new Date(),
				partId: item.partId,
				quantity: item.onHand,
				ncmCodeId: 0,
				description: null,
				customerFound: false,
			}
    },
    readyMadePOLineInventory(item) {
      return {
        purchaseOrderId: item.purchaseOrderId,
        companyName: item.companyName,
        poDate: item.poDate,
        partNumber: item.partNumber,
        description: item.description
			}
    },
    toggleFilter(checked) {
      // this.fiteredInventory = checked ? this.flavours.slice() : []
      console.log(checked, 'Value')
    },
    onPartInventoryCreated() {
      this.getInventoryAvailableParts(this.partId);
      this.$emit('inventory-created');
    }
  },
  watch: {
    partId() {
      if(!this.partId && this.clearListOnPart) { this.setInventoryListForPart({partId:this.partId,data:[]})}
      this.getInventoryAvailableParts(this.partId);
    },
    checkedRowItemIds() {
      if (this.parentItems.length > 0) {
        this.$emit('checkedItems', this.checkedRowItemIds);
      } else {
        const filteredObjArr = this.itemData.filter((obj) => this.checkedRowItemIds.includes(obj.id));

        this.checkedRowItemsObjArr = filteredObjArr.map(({ id, onHand, partId, cost, active }) => {
          return {
            id: 0,
            requirementLineId: this.crfqLineId,
            quoteLineId: this.quoteLineId,
            inventoryId: id,
            quantity: onHand || 0,
            partId,
            cost: cost || 0,
            active,
          };
        });
      }
    },
    async inventoryId() {
      await this.getInventoryFiltered({id: this.inventoryId});
    },
    async purchaseOrderLineId(){
      await this.getInventoryFiltered({purchaseOrderLineId: this.purchaseOrderLineId});
    },
    inventorySourceFilters: {
      async handler() {
        this.$emit('searching', true);
        await this.getInventoryFiltered(this.inventorySourceFilters).then(() => this.$emit('searching', false));
      },
      deep: true,
    },
    fiteredInventory(newVal, oldVal) {
      // Handle changes if all
      if (!oldVal.includes(0) && newVal.includes(0)) {
        this.fiteredInventory = this.filterOptions.map(x => x.value);
      } else if (oldVal.includes(0) && !newVal.includes(0)) {
        this.fiteredInventory = [1];
      } else if (newVal.includes(0) && newVal.length != this.filterOptions.length) {
        const ndx = this.fiteredInventory.indexOf(0);
        this.fiteredInventory.splice(ndx, 1);
      }
    },
  },
  async mounted() {
    
    //clear list data
    if(!this.partId && this.clearListOnPart) { this.setInventoryListForPart({partId:this.partId,data:[]})}
    if(this.partId) { this.getInventoryAvailableParts(this.partId); }
    if (this.inventoryId) {
      await this.getInventoryFiltered({id: this.inventoryId});
    }
    if (this.parentCheckedItems.length > 0 && this.parentItems.length > 0) {
      this.checkedRowItemIds = this.parentCheckedItems;
    }

    eventBus.$on('chgPartId', (part) => {
      //console.log(part);
      //alert('eventBus: ' + part.id);
      this.partId = part.id;
      //this.getInventoryByPartId(part.id);
      //this.getInventoryListForPart();
    });
  },
};
</script>

<style lang="scss" scoped>
  .inventory-list {
    margin-top: 20px;
  }
  .inventory--tab {
    .grid-header {
      margin-bottom: 5px;
  }
}
</style>
